import {
  type AiCreditOption,
  type CopilotQuotaQuery,
  copilotQuotaQuery,
  createAiCreditCheckoutMutation,
  createAiCreditPortalSessionMutation,
} from '@affine/graphql';
import { Store } from '@toeverything/infra';

import type { GraphQLService } from '../services/graphql';

export type CopilotQuotaInfo = NonNullable<
  CopilotQuotaQuery['currentUser']
>['copilot']['quota'];

export class UserCopilotQuotaStore extends Store {
  constructor(private readonly graphqlService: GraphQLService) {
    super();
  }

  async fetchUserCopilotQuota(abortSignal?: AbortSignal) {
    const data = await this.graphqlService.gql({
      query: copilotQuotaQuery,
      context: {
        signal: abortSignal,
      },
    });

    if (!data.currentUser) {
      throw new Error('No logged in');
    }

    return data.currentUser.copilot.quota;
  }

  async createAiCreditCheckout(option: AiCreditOption, returnPath: string) {
    const data = await this.graphqlService.gql({
      query: createAiCreditCheckoutMutation,
      variables: { option, returnPath },
    });
    return data.createAiCreditCheckout;
  }

  async createAiCreditPortalSession(returnPath: string) {
    const data = await this.graphqlService.gql({
      query: createAiCreditPortalSessionMutation,
      variables: { returnPath },
    });
    return data.createAiCreditPortalSession;
  }
}
